exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.disabled-music{\n    background: #bdbdbd;\n}\nimg{\n    width: 100%;\n    height: auto;\n}\naudio{\n    width: 100%;\n}\n#upload_image{\n    width: 100%;\n}\n.album-art{\n    height: 100px;\n    width: 100px;\n}\n.music-description{\n    position: absolute;\n    top: 15px;\n    left: 130px;\n}\n.music-photo{\n    display: table-cell;\n    vertical-align: top;\n}\n.music-description{\n    display: table-cell;\n    vertical-align: top;\n}\n.hidden{\n    display: none !important;\n}\n.music-title{\n    font-weight: 500;\n}\n.music-artist{\n    display: block;\n}\n.music-uploader{\n    display: block;\n}\n\n", ""]);

// exports
